import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "./swiper.scss";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
interface CarouselProps {
    images: string[];
}

const Carousel: React.FC<CarouselProps> = ({ images }) => {
    return (
        <Swiper modules={[Navigation, Pagination]}
        
        loop={true}
        navigation={{
            nextEl: ".next",
            prevEl: ".prev",
        }}
        pagination={{ 
            el: ".pag",
         }}
        spaceBetween={0} slidesPerView={1} id="unit-carousel">
            {images.map((image, index) => {
                return (
                    <SwiperSlide className="swiper" key={index}>
                        <div
                            style={{ backgroundImage: `url(${image})` }}
                            className="background-image"
                        />
                    </SwiperSlide>
                );
            })}
            <div className="nav-pag-wrapper">
                <div className="prev">
                    <img src="/ui/pag-arrow.svg" alt="Previous" />
                </div>
                <div className="next">
                    <img src="/ui/pag-arrow.svg" alt="Next" />
                </div>
                <div className="pag"></div>
            </div>
        </Swiper>
    );
};

export default Carousel;
